/* eslint-disable */
import { createContext, useState, useEffect, useContext, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Audience as AudienceList, AudienceMedia, AudiencePrint, AudienceMediaComp, UpdateAudienceMediaComp } from "../services/AudienceService";
import { ValidAccessTokenLocalStorage, getAccessTokenLocalStorage } from "./utils"
import { subtractMinutes, applySpecificTime } from '../utils/dateTimeUtils';
import { UserPreferenceContext } from "./UserPreferenceContext";
import {
  AudiencePrintMerge, AudienceMediaMinute, AudienceMediaMerge, AudienceMerge, AudienceMinute, AudienceMediaCompMinute,
  doAudienceHandleReturnWithWError401, doAudienceHandleReturnWithWError96, AudiencePrintMediaMerge, AudienceMediaCompPrintMerge
} from "./AudienceContextUtils";
import { NetworkAlertContext } from './NetworkAlertContext';
import { usePreference } from "./usePreference";
import moment from "moment";
import { ImageEmissora as ImageEmissoraList } from "../services/ImageEmissoraService";
import { DatePraca } from "../services/DateService";
import PropTypes from 'prop-types';


export const AudienceContext = createContext();

const AudienceProvider = ({ children }) => {
  const u = usePreference();
  const { userAuthenticated, setUserAuthenticated, setUserMenssageApi, updateUserPreference } = useContext(UserPreferenceContext);
  const { setShowError, setInfoSpan, setShowInfo, setInfoError } = useContext(NetworkAlertContext);
  const [audience, setAudience] = useState([]);
  const [audiencePrint, setAudiencePrint] = useState([]);
  const [audienceMedia, setAudienceMedia] = useState([]);
  const [audienceMediaCompPrint, setAudienceMediaCompPrint] = useState([]);
  const [audienceFirstTable, setAudienceFirstTable] = useState([]);
  const [audienceMediaFirstTable, setAudienceMediaFirstTable] = useState([]);
  const { t: translateText } = useTranslation();
  const [qtdMinutos, setQtdMinutos] = useState(30);
  const [qtdMinutosMedia, setQtdMinutosMedia] = useState(31);
  const qtdMinutosRef = useRef(qtdMinutos);
  const qtdMinutosMediaRef = useRef(qtdMinutosMedia);
  const [lastMinute, setLastMinute] = useState();
  const [lastAudience, setLastAudience] = useState();
  const [lastThirtyAudience, setLastThirtyAudience] = useState();
  const [lastThirtyAudiencePie, setLastThirtyAudiencePie] = useState();
  const [audienceMediaComp, setAudienceMediaComp] = useState([]);
  const [audienceMediaCompFirstTable, setAudienceMediaCompFirstTable] = useState([]);

  useEffect(() => {
    qtdMinutosRef.current = qtdMinutos;
    qtdMinutosMediaRef.current = qtdMinutosMedia;

  }, [qtdMinutos, qtdMinutosMedia]);
  function changeBaseMinute(minute) {
    qtdMinutosRef.current = qtdMinutosRef.current + minute;
  }
  function changeBaseMinuteMedia(minute) {
    qtdMinutosMediaRef.current = qtdMinutosMediaRef.current + minute;
  }
  async function doAudience() {
    setInfoSpan(translateText('network.loadingData'));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await AudienceList(token, qtdMinutosRef.current).then(res => {
        const dadosRating = res?.data?.ListDadosRating;
        doAudienceHandleReturnSuccess(dadosRating);

        const lastHourMinute = dadosRating[0][1];
        u.setHoraFinCalendar(lastHourMinute);
        hideShowInfo();
      })
        .catch(err => {
          doAudienceHandleReturnWithWError(err);
        });
      if (u.userPreference.UserAutoScroll)
        await DatePraca(token, u.userPreference.Country.CountryID, u.userPreference.Praca.Id).then(res => {
          if (res.status === 200) {
            u.userPreference.Horario = res.data;
          }
        });
    }
  };
  function resetQtdMinutos() {
    setQtdMinutos(30);
    qtdMinutosRef.current = qtdMinutos;
    const divTableMinuteRight = document.getElementById('divTableMinuteRight');
    if (divTableMinuteRight != null)
      divTableMinuteRight.scrollTop = 0;
  }
  function resetQtdMinutosMedia() {
    setQtdMinutosMedia(31); // Reseta para o valor inicial
    qtdMinutosMediaRef.current = 31;
    // Reset do scroll se necessário
    const divMediaComponent = document.getElementById('divMediaComponent');
    if (divMediaComponent != null) {
      const scrollableElements = divMediaComponent.querySelectorAll('.scrollable');
      scrollableElements.forEach(el => {
        if (el) el.scrollTop = 0;
      });
    }
  }
  function getUltimoNLoading() {
    const dateNow = moment(u.userPreference.Horario?.substring(0, 19), 'YYYY-MM-DDTHH:mm:ss').subtract(1, 'minutes');
    const dateIni = applySpecificTime(dateNow, moment(u.userPreference.HorarioIni).format('HH:mm'));

    const additionalMinutes = u.minuteImage || 0;
    const dateForUltimoNLoading = subtractMinutes(dateNow, qtdMinutosRef.current - 30 + additionalMinutes, dateIni);

    return dateForUltimoNLoading.format('HH:mm');
  }
  async function doAudienceImageEmissora() {
    setInfoSpan(translateText('network.loadingData'));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await ImageEmissoraList(token, getUltimoNLoading()).then(res => {
        const dadosRating = res?.data?.ListDadosRating;
        if (res.data.CodErro !== 0) {
          throw new Error(JSON.stringify(res));
        }
        doAudienceHandleReturnSuccess(dadosRating);

        const lastHourMinute = dadosRating[0][1];
        u.setHoraFinCalendar(lastHourMinute);
        hideShowInfo();
      })
        .catch(err => {
          let errorData;
          try {
            errorData = JSON.parse(err.message);
          } catch (e) {
            errorData = { message: err.message };
          }
          doAudienceHandleReturnWithWError({ "response": errorData });
        });

      if (u.userPreference.UserAutoScroll)
        await DatePraca(token, u.userPreference.Country.CountryID, u.userPreference.Praca.Id).then(res => {
          if (res.status === 200) {
            u.userPreference.Horario = res.data;
            updateUserPreference({ data: u.userPreference });

          }
        });
    }
  };

  function hideShowInfo() {
    setTimeout(() => setShowInfo(false), 3000);
  }

  async function doAudiencePrint(data, horaIni, horaFin) {
    if (data === undefined || horaIni === undefined || horaFin === undefined) { return; }
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await AudiencePrint(token, data, horaIni, horaFin
      ).then(res => {
        AudiencePrintMerge(res, setAudiencePrint);
      })
        .catch(err => { });
    }
  };
  async function doAudienceMediaPrint() {
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await AudienceMedia(token).then(res => {
        AudiencePrintMediaMerge(res, setAudiencePrint);
      })
        .catch(err => { });
    }
  };

  async function doAudienceMediaCompPrint(dataini, indiceaverage) {
    if (dataini === undefined || indiceaverage === undefined) { return; }
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await AudienceMediaComp(token, dataini, indiceaverage).then(res => {
        AudienceMediaCompPrintMerge(res, setAudienceMediaCompPrint);
      })
        .catch(err => { });
    }
  };

  async function doAudienceMedia() {
    setInfoSpan(translateText('network.loadingData'));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await AudienceMedia(token).then(res => {
        doAudienceMediaLoadSuccess(res);
        const dados = res?.data?.ListHeader;
        const lastHourMinute = dados[0][0].split('-')[1].trim();
        const firstHourMinute = dados[0][0].split('-')[0].trim();
        u.setHoraFinCalendar(lastHourMinute);
        u.setHoraIniCalendar(firstHourMinute);
        hideShowInfo();
      })
        .catch(err => {
          doAudienceMediaError(err);
        });
      if (u.userPreference.UserAutoScroll)
        DatePraca(token, u.userPreference.Country.CountryID, u.userPreference.Praca.Id).then(res => {
          if (res.status === 200) {
            u.userPreference.Horario = res.data;
          }
        });
    }
  };


  async function doAudienceMediaComp(dataini, indiceaverage) {
    setInfoSpan(translateText('network.loadingData'));
    setShowInfo(true);
    if (dataini === undefined || indiceaverage === undefined) { return; }
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await AudienceMediaComp(token, dataini, indiceaverage).then(res => {

        doAudienceMediaCompLoadSuccess(res);

        return res;
      })
        .catch(err => {
          doAudienceMediaCompError(err);
        });
    }
  };


  async function doUpdateMediaComp(indiceaverage, dataaverage, horainiaverage, horafimaverage, autoupdate, mcaction) {
    setInfoSpan(translateText('network.loadingData'));
    setShowInfo(true);
    if (indiceaverage === undefined || dataaverage === undefined ||
      horainiaverage === undefined || horafimaverage === undefined ||
      autoupdate === undefined || mcaction === undefined) { return; }
    let token = getAccessTokenLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      await UpdateAudienceMediaComp(token, indiceaverage, dataaverage, horainiaverage, horafimaverage, autoupdate, mcaction).then(res => {

        doUpdateAudienceMediaCompLoadSuccess(res);

        return res;
      })
        .catch(err => {
          doUpdateMediaCompError(err);
          throw err;
        });
    }
  };

  const objMemoProvider = useMemo(
    () => ({
      lastThirtyAudiencePie,
      lastThirtyAudience,
      audience,
      audienceMedia,
      audienceMediaComp,
      audiencePrint,
      audienceMediaCompPrint,
      audienceFirstTable,
      audienceMediaFirstTable,
      audienceMediaCompFirstTable,
      lastMinute,
      doAudience,
      doAudiencePrint,
      doAudienceMediaPrint,
      doAudienceMediaCompPrint,
      doAudienceMedia,
      doAudienceMediaComp,
      doUpdateMediaComp,
      doAudienceImageEmissora,
      changeBaseMinute,
      changeBaseMinuteMedia,
      setAudience,
      setAudienceFirstTable,
      setLastAudience,
      setAudienceMedia,
      setAudienceMediaFirstTable,
      lastAudience,
      qtdMinutos,
      setQtdMinutos,
      resetQtdMinutos,
      resetQtdMinutosMedia,
      setQtdMinutosMedia
    }
    ),
    [lastThirtyAudiencePie,
      lastThirtyAudience,
      audience,
      audienceMedia,
      audienceMediaComp,
      audiencePrint,
      audienceMediaCompPrint,
      doAudienceMediaPrint,
      audienceFirstTable,
      audienceMediaFirstTable,
      audienceMediaCompFirstTable,
      lastMinute,
      doAudience,
      doAudienceMedia,
      doAudienceMediaComp,
      doUpdateMediaComp,
      doAudienceImageEmissora,
      lastAudience,
      qtdMinutos,
      resetQtdMinutos]
  );
  return (
    <div id='divAudienceContext'>
      <AudienceContext.Provider
        value={objMemoProvider}>
        {children}
      </AudienceContext.Provider>
    </div>
  );

  function doAudienceMediaLoadSuccess(response) {
    let merge = response?.data?.ListDados.length > response?.data?.ListHeader.length;
    let qtdMinutosMedia = merge ? qtdMinutosMediaRef.current * 2 : qtdMinutosMediaRef.current;
    AudienceMediaMinute(response, setLastMinute, setAudienceMediaFirstTable, qtdMinutosMedia);
    AudienceMediaMerge(response, setLastAudience, setLastThirtyAudiencePie, setLastThirtyAudience, setAudienceMedia, setAudienceMediaFirstTable, audienceMediaFirstTable, qtdMinutosMedia);
    if (Number(response.data.CodErro) !== 0) {
      setShowError(true);
      setInfoError(response.data.MsgErro);
    } else {
      setShowInfo(false);
    }
  }

  function doAudienceMediaCompLoadSuccess(response) {
    AudienceMediaCompMinute(response, setAudienceMediaCompFirstTable);

    if (Number(response.data.CodErro) !== 0) {
      setShowError(true);
      setInfoError(response.data.MsgErro);
    } else {
      setShowInfo(false);
    }
  }

  function doUpdateAudienceMediaCompLoadSuccess(response) {
    if (Number(response.data.Code) !== 0) {
      setShowError(true);
      setInfoError(response.data.MsgErro);
    } else {
      setShowInfo(false);
    }
  }
  function doAudienceHandleReturnSuccess(listDadosRating) {
    if (listDadosRating != null) {
      doAudienceLoad(listDadosRating);
      setShowInfo(false);
    }
  }
  function doAudienceLoad(listDadosRating) {
    AudienceMerge(listDadosRating, setLastMinute, setAudience, setLastThirtyAudiencePie, setLastThirtyAudience, setLastAudience);
    AudienceMinute(listDadosRating, setAudienceFirstTable);
  }
  function doAudienceHandleReturnWithWError(resultError) {
    const dataResponse = resultError?.response?.data;
    doAudienceHandleReturnWithWError401(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
    doAudienceHandleReturnWithWError96(dataResponse, setAudience, setAudienceFirstTable, setShowError, setInfoError, setInfoSpan);
    doAudienceHandleReturnWithWError98(dataResponse);
  }
  function doAudienceHandleReturnWithWError98(dataResponse) {
    if (Number(dataResponse.CodErro) === 98) {
      const msgErro = dataResponse?.MsgErro;
      setInfoSpan(translateText(msgErro));
      doAudienceLoad(dataResponse?.ListDadosRating);
      hideShowInfo();
    }
  }
  function doAudienceMediaError(responseError) {
    if (Number(responseError?.response?.data?.CodErro) === 96) {
      setAudienceMedia(null);
      setAudienceMediaFirstTable(null);
      setInfoError(responseError?.response?.data?.MsgErro)
      setShowError(true);
    }
    doAudienceHandleReturnWithWError(responseError);
  }
  function doAudienceMediaCompError(responseError) {
    if (Number(responseError?.response?.data?.CodErro) != 0) {
      setAudienceMediaComp(null);
      setAudienceMediaCompFirstTable(null);
      setInfoError(responseError?.response?.data?.MsgErro)
      setShowError(true);
    }
  }

  function doUpdateMediaCompError(responseError) {
    if (Number(responseError?.response?.data?.Code) != 0) {
      setAudienceMediaComp(null);
      setAudienceMediaCompFirstTable(null);
      setInfoError(responseError?.response?.data?.Message)
      setShowError(true);
    }
  }
}
AudienceProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AudienceProvider;